// extracted by mini-css-extract-plugin
module.exports = {"component":"WrongNetworkPopUp_component__2ex_c","text":"WrongNetworkPopUp_text__2M3Lv"};